module.exports = __webpack_public_path__ + "media/application/images/partners/crif@2x-27f6b827953c750b910ff87b11f1a3e17dd8401a4aef3985d52387349b81ddcc.png";